import script from "./VTaskStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./VTaskStatus.vue?vue&type=script&setup=true&lang=ts"

import "./VTaskStatus.vue?vue&type=style&index=0&id=fe45c7cc&lang=scss"

const __exports__ = script;

export default __exports__